import { useTranslations } from 'next-intl';

import ReviewLogo from '@/fo/icons/base/logos/review-logo.svg';
import { Question } from '@/fo/ui/review/catalog/base';
import { utilPluralize } from '@/fo/util/pluralize';

import { CardWrapper } from '../CardWrapper/CardWrapper';

import { styles } from './QuestionCard.styles';

export interface QuestionCardProps {
  question: Question;
  className?: string;
  onClick?: () => void;
}

export function QuestionCard({
  question,
  className,
  onClick
}: QuestionCardProps) {
  const t = useTranslations();
  const slots = styles();

  const pluralizeAge = utilPluralize({
    one: t('pluralize.age.one'),
    few: t('pluralize.age.few'),
    many: t('pluralize.age.many')
  });

  const ageText = question.author.age
    ? `${question.author.age} ${pluralizeAge(question.author.age)}`
    : null;

  const header = (
    <div className={slots.header()}>
      <span className={slots.authorInfo()}>
        {question.author.name}
        {ageText && ` / ${ageText}`}
        {question.author.skinType &&
          ` / ${question.author.skinType} ${t('skin')}`}
      </span>
      <span>{question.date}</span>
    </div>
  );

  const content = (
    <div className={slots.content()}>
      <p className={slots.question()}>{question.question}</p>
      <div className={slots.answerContainer()}>
        <div className={slots.answerHeader()}>
          <span>
            <ReviewLogo />
          </span>
          <span>{t('review.labels.naosRepresentative')}</span>
        </div>
        <p className={slots.answerText()}>{question.response?.text}</p>
      </div>
    </div>
  );

  return (
    <CardWrapper
      className={className}
      header={header}
      content={content}
      actionButtonText={t('review.buttons.readFullAnswer')}
      onActionButtonClick={onClick}
    />
  );
}
